import { render, staticRenderFns } from "./newTabbar.vue?vue&type=template&id=595296f8&scoped=true&"
import script from "./newTabbar.vue?vue&type=script&lang=js&"
export * from "./newTabbar.vue?vue&type=script&lang=js&"
import style0 from "./newTabbar.vue?vue&type=style&index=0&id=595296f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595296f8",
  null
  
)

export default component.exports